import React, { useContext, useEffect, useState } from "react";
import "./Subtotal.css";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import {
  buttonClickTracker,
  doNFOTransactionResponse,
  getCheckoutOptionsFromPincodeAPI,
} from "../../../../Utils/CheckoutAPIs/CheckoutAPIs";
import { Alert } from "@mui/material";
import loader from "../../../../Assets/svgs/loader.svg";
import { useNavigate } from "react-router-dom";
import { trackData } from "../../../../Utils/attribution/CheckoutAttribution";
import { CartContext } from "../../../../App";

interface SubtotalProps {
  stateCheckoutItems: ItemDetailsData[];
  cbHandlePaymentClick: (orderIds?: doNFOTransactionResponse) => void;
}

interface Error {
  firstName: string;
  lastName: string;
  school: string;
  mobileNumber: string;
  email: string;
  address: string;
  flatNo: string;
  city: string;
  state: string;
  pincode: string;
  schoolName: string;
}

const Subtotal = (props: SubtotalProps) => {
  let currentItemIds: number[] = [];
  for (let i = 0; i < props.stateCheckoutItems.length; i++) {
    currentItemIds.push(props.stateCheckoutItems[i].id);
  }
  const {
    userDetails,
    setUserDetails,
    backendSchool,
    isOtpVerified,
    nfoSelected,
  } = useContext(CartContext);
  const [stateCurrentItemIds, setStateCurrentItemIds] =
    useState<number[]>(currentItemIds);

  const [isPurchaseButtonClicked, setIsPurchaseButtonClicked] = useState(false);
  const referredBy = sessionStorage.getItem("referredBy");

  const [error, setError] = useState<Partial<Error>>({});
  const navigate = useNavigate();

  const [showAlert, setShowAlert] = useState({
    isAlertVisible: false,
    alert: "",
  });

  const keys = [
    "firstName",
    "lastName",
    "email",
    "mobileNumber",
    "address",
    "flatNo",
    "city",
    "state",
    "pincode",
  ];
  const values = keys.map((key) => sessionStorage.getItem(key));
  const fieldNames = [
    "firstName",
    "lastName",
    "email",
    "mobileNumber",
    "address",
    "flatNo",
    "city",
    "state",
    "pincode",
  ];
  const missingFields = fieldNames.filter((_, index) => !values[index]);

  const PurchaseNFO = async () => {
    const emailValidation =
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    const mobileValidation = /^[1-9]{1}[0-9]{9}$/;
    const dubaiMobileValidation =
      /^((\+971|971|0)?(50|51|52|54|55|56|58|4))\d{7}$/;
    const pincodeValidation = /^[1-9][0-9]{5}$/;
    let flag = 0;
    if (userDetails.firstName.length < 3) {
      flag = 1;
      console.log("First name problem");
      setShowAlert({
        isAlertVisible: true,
        alert:
          "The given first name is invalid. Please check the given first name.",
      });
    } else if (userDetails.lastName.length < 3) {
      flag = 1;
      console.log("Last name problem");
      setShowAlert({
        isAlertVisible: true,
        alert:
          "The given last name is invalid. Please check the given last name.",
      });
    } else if (
      nfoSelected &&
      (userDetails.grade < 5 || userDetails.grade > 12)
    ) {
      console.log("Grade problem");
      flag = 1;
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid grade.",
      });
    } else if (
      nfoSelected &&
      (!userDetails.schoolName || userDetails.schoolName.length < 5)
    ) {
      flag = 1;
      console.log("School name problem");
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid school name.",
      });
    } else if (
      userDetails.address.length < 5 ||
      userDetails.address.length > 80
    ) {
      flag = 1;
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid address.",
      });
    } else if (userDetails.flatNo.length < 1) {
      flag = 1;
      console.log("Flat number problem");
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid flat/house number.",
      });
    } else if (userDetails.city.length < 2) {
      flag = 1;
      console.log("City problem");
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid city.",
      });
    } else if (userDetails.state.length < 2) {
      flag = 1;
      console.log("State problem");
      setShowAlert({
        isAlertVisible: true,
        alert: "Please select a valid state.",
      });
    } else if (!pincodeValidation.test(userDetails.pincode)) {
      flag = 1;
      console.log("Pincode problem");
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid pincode.",
      });
    } else if (
      !(backendSchool.isInternational
        ? dubaiMobileValidation.test(userDetails.mobileNumber || "")
        : mobileValidation.test(userDetails.mobileNumber || ""))
    ) {
      console.log("mobile number problem", userDetails.mobileNumber);
      flag = 1;
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid mobile number.",
      });
    } else if (!emailValidation.test(userDetails.email)) {
      flag = 1;
      console.log("email problem");
      setShowAlert({
        isAlertVisible: true,
        alert: "Please enter a valid email.",
      });
    } else if (missingFields.length > 0) {
      flag = 1;
      console.log(missingFields);
      setShowAlert({
        isAlertVisible: true,
        alert: `Please fill in the following required fields: ${missingFields.join(
          ", "
        )}`,
      });
    } else {
      flag = 0;
      setError({
        firstName: "",
        lastName: "",
        address: "",
        flatNo: "",
        city: "",
        state: "",
        pincode: "",
        mobileNumber: "",
        email: "",
        schoolName: "",
      });
    }
    if (flag === 0) {
      setIsPurchaseButtonClicked(true);

      if (isOtpVerified) {
        const pincode = userDetails.pincode;
        const checkoutOptions = await getCheckoutOptionsFromPincodeAPI(
          pincode,
          userDetails.mobileNumber
        );
        console.log("checkoutOptions", checkoutOptions);
        trackData(
          "preorder_user_clicks_on_purchase_button",
          userDetails.firstName + " " + userDetails.lastName,
          userDetails.mobileNumber
        );
        // Get current item IDs from the actual cart items, not sessionStorage
        const currentItemIds = props.stateCheckoutItems
          .map((item) => item.id)
          .join("-");

        buttonClickTracker(
          currentItemIds === "1"
            ? "personal_finance_handbook_grade_1_and_2_initiate_checkout"
            : "unknown_initiate_checkout"
        );

        if (checkoutOptions.status === "Success") {
          sessionStorage.setItem(
            "prepaid",
            checkoutOptions.data.prepaid.toString()
          );
          sessionStorage.setItem("cod", checkoutOptions.data.cod.toString());
          navigate("/SummaryPage");
        } else {
          setShowAlert({
            isAlertVisible: true,
            alert: "Oops! Something went wrong. Please try again later.",
          });
        }
      } else {
        setShowAlert({
          isAlertVisible: true,
          alert: "Please verify the OTP first.",
        });
        setIsPurchaseButtonClicked(false);
      }
    }
  };

  useEffect(() => {
    if (showAlert.alert) {
      setTimeout(() => {
        setShowAlert({
          isAlertVisible: false,
          alert: "",
        });
      }, 5000);
    }
  }, [showAlert.alert]);

  return (
    <div className="subtotal">
      <div className="group-2">
        <button
          className="subtotal-button"
          onClick={() => {
            trackData("proceed_to_checkout");
            PurchaseNFO();
            console.log("isOtpVerified", isOtpVerified);
          }}
          disabled={isPurchaseButtonClicked}
        >
          {!isPurchaseButtonClicked && (
            <div className="text-wrapper-11">Proceed to Checkout</div>
          )}
          {isPurchaseButtonClicked && (
            <img className="text-wrapper-11" src={loader} alt="O" />
          )}
        </button>
      </div>

      {showAlert.alert && (
        <Alert
          style={{
            borderRadius: 10,
            opacity: 1,
          }}
          severity="error"
        >
          {showAlert.alert}
        </Alert>
      )}
    </div>
  );
};

export default Subtotal;
